import React from 'react'

const EmailTrash = () => {
  return (
    <div>Trash</div>
  )
}

export default EmailTrash